//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "resumelist",
  data() {
    return {
      list: [{name: '销售经理', education: '本科', time: '经验不限', address: '广州 南宁 西宁'},
        {name: '销售经理（OEM代工）', education: '本科', time: '经验不限', address: '北京'},
        {name: 'C/C++软件开发工程师', education: '本科', time: '1-3年', address: '北京'},
        {name: '软件开发工程师', education: '本科', time: '1-3年', address: '北京'},
        {name: '硬件测试工程师', education: '本科', time: '经验不限', address: '北京'},
        {name: '装配工程师', education: '本科', time: '经验不限', address: '北京'},
        {name: '质量主管/经理', education: '本科', time: '经验不限', address: '北京'},
        {name: '检验工程师', education: '本科', time: '经验不限', address: '北京'},
        {name: '结构工程师', education: '本科', time: '经验不限', address: '北京'},
        {name: '前端开发工程师', education: '本科', time: '1-3年', address: '北京'}]
    }
  },
  methods: {
    goToresume(name) {
      this.$router.push({name: 'resume', query: {name}})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/job/resumelist.vue